"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCsvButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../common-styled-components");
const csvExportUtils_1 = require("../../../util/csvExportUtils");
const ExportCsvButton = ({ rows, columns, tableName, label = "Export CSV", }) => {
    const onExport = () => {
        const csv = (0, csvExportUtils_1.serializeCsv)(rows, columns);
        (0, csvExportUtils_1.triggerCsvDownload)(csv, (0, csvExportUtils_1.getCsvFilename)(tableName));
    };
    return (0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { onClick: onExport, children: label });
};
exports.ExportCsvButton = ExportCsvButton;
